import { render, staticRenderFns } from "./ViewSms.vue?vue&type=template&id=e0549ace&scoped=true"
import script from "./ViewSms.vue?vue&type=script&lang=js"
export * from "./ViewSms.vue?vue&type=script&lang=js"
import style0 from "./ViewSms.vue?vue&type=style&index=0&id=e0549ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0549ace",
  null
  
)

export default component.exports